import { i18n } from '@/base/helpers';

export const getDataButton = ({ display, account, coupon, cartValue, status, message, onAbout }) => {
  let textButton;
  let clickButton;
  let textInfo;
  let isDisabled = false;
  let classButton = 'beans-redemption-state-neutral';
  const {
    beans_name: beansName,
    beans_ccy_spent: beansCCYSpent,
    beans_new_account: beansNewAccount,
    redemption,
    currency: { symbol },
  } = display;

  if (status === 'pending:apply') {
    textButton = i18n.t('button', 'applying');
    classButton = 'beans-redemption-state-applying';
    clickButton = () => {};
    isDisabled = true;
  } else if (status === 'pending:cancel') {
    textButton = i18n.t('button', 'cancelling_redemption');
    classButton = 'beans-redemption-state-cancelling';
    clickButton = () => {};
    isDisabled = true;
  } else if (account && coupon && coupon.uid) {
    textInfo = i18n.t('button', 'use_coupon', {
      coupon_code: coupon.uid,
      coupon_amount: i18n.printMoney(symbol, coupon.amount),
    });
    classButton = 'beans-redemption-state-applied';
    textButton = i18n.t('redemption', 'cancel_redemption');
    clickButton = window.Beans3.Liana.Redemption.cancel;
  } else if (account && cartValue && account.beans < redemption.min_beans) {
    const willEarn = ~~((beansCCYSpent * cartValue) / 100);
    textButton = i18n.t('button', 'get_points', { quantity: willEarn.toLocaleString(), beans_name: beansName });
    classButton = 'beans-redemption-state-about';
    clickButton = onAbout;
  } else if (account && cartValue) {
    const redemptionQuantity = Math.min(account.beans, (cartValue * redemption.max_percentage) / 100);
    textButton = i18n.t('redemption', 'redeem_points', {
      quantity: redemptionQuantity.toLocaleString(),
      valueCCY: i18n.printMoney(symbol, redemptionQuantity / 100),
      beans_name: beansName,
    });
    classButton = 'beans-redemption-state-apply';
    clickButton = window.Beans3.Liana.Redemption.apply;
  } else if (cartValue) {
    const bonus = ~~((beansCCYSpent * cartValue + 100 * beansNewAccount) / 100);
    textButton = i18n.t('button', 'get_points', { quantity: bonus.toLocaleString(), beans_name: beansName });
    classButton = 'beans-redemption-state-join';
    clickButton = onAbout;
  } else {
    textButton = i18n.t('button', 'pay_with', { beans_name: beansName });
    classButton = 'beans-redemption-state-pay';
    clickButton = onAbout;
  }

  if (status === 'error' && message) {
    textInfo = message;
  }

  return { textButton, clickButton, classButton, textInfo, isDisabled };
};

export const getDataProductButton = (
  display,
  account,
  coupon,
  productID,
  variantID,
  variantPrice,
  onAbout,
  status,
  message
) => {
  let buttonText;
  let handleClick;

  const defaultButtonText = `Redeem with ${parseInt(variantPrice, 10).toLocaleString()} ${display.beans_name}`;

  if (status === 'pending:apply') {
    buttonText = i18n.t('button', 'applying');
    handleClick = () => {};
  } else if (status === 'pending:cancel') {
    buttonText = i18n.t('button', 'cancelling_redemption');
    handleClick = () => {};
  } else if (account && coupon && coupon.uid) {
    buttonText = i18n.t('redemption', 'cancel_redemption');
    handleClick = window.Beans3.Liana.Redemption.cancel;
  } else if (account && account.beans >= variantPrice) {
    buttonText = defaultButtonText;
    handleClick = () => {};
  } else if (account) {
    buttonText = defaultButtonText;
    handleClick = onAbout;
  } else {
    buttonText = defaultButtonText;
    handleClick = onAbout;
  }

  if (status === 'error' && message) {
    buttonText = message;
  }
  return { buttonText, handleClick };
};
